import { useEffect, useState } from "react";
import { GetCategoryBlogByIdData } from "../../../lib/data";
import { positionOfCategoiresBlog, statusOfCategoriesBlog } from "../../../lib/definitions";
import EditCategoiresBlogUi from "../../../ui/categoriesBlog/editCategoriesBlogUi";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";

export default function EditCategoiresBlog () {

    const [categoryByIdData, setCategoryByIdData] = useState({});
    const {categoryBlogId} = useParams();
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const categoryData = await GetCategoryBlogByIdData(categoryBlogId);
        console.log(categoryData)
        setCategoryByIdData({});
        setCategoryByIdData(categoryData);
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.category")}</h1>
                <EditCategoiresBlogUi categoryByIdData={categoryByIdData} positionOfCategoiresBlog={positionOfCategoiresBlog} statusOfCategoriesBlog={statusOfCategoriesBlog}  />
            </div>
        </div>
    );
};